import React from 'react'
import { useIntl } from 'react-intl'
import { Fade } from 'components/GeneralComponents/Animations'
import { useLoadingType } from 'services/utils'

const LoadingNotice = () => {
  const intl = useIntl()
  const loadingType = useLoadingType()
  return (
    <Fade in>
      {loadingType !== 'DONE' &&
        intl.formatMessage({ id: `loadingType.${loadingType.toLowerCase()}` })}
    </Fade>
  )
}

export default LoadingNotice
